module.exports = __webpack_public_path__ + "img/page_info_family.1dcf513.svg";